module.exports = __webpack_public_path__ + "img/ambientacion.42f496cc.jpg";